// ============================================================================
// view.weather — receipt-backed no-server-read surface
// ============================================================================
// WeatherPage has no route-local Supabase read or command. Its public forecast
// is owned independently by weatherForecastSource, while its Header keeps the
// authenticated task/notification shell resources separately scoped. The
// receipt records those adjacent owners without inventing an empty route
// catalog resource. This declaration does not grant boot independence; the
// reviewed boot-release ledger and matching release receipt do that separately.
// ============================================================================

import type {NoServerReadSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: NoServerReadSurfaceDeclaration = Object.freeze({
  surface: 'view.weather',
  disposition: 'no-server-read',
});

export default declaration;
